import { STATUS_LIST } from "../controlTower/utility/constants";

// Utility to determine if the edit functionality should be disabled for Address and Dates and Status tabs
export function isEditDisabled({
  isUserAdmin,
  isLastPath,
  activeTabLabel,
  sortedMileStoneDetails,
  milestoneIndex,
  sortedMileStoneIndex,
  controlTowerPermissions,
}) {
  const lastMilestone = sortedMileStoneDetails[sortedMileStoneDetails.length - 1];
  const isDestinationHub = lastMilestone?.toLocation.locType === "HUB";
  const isQuoteStarted = lastMilestone?.pathDetails.quoteStatus !== null;
  const isArrivalPresent = lastMilestone?.pathDetails.arrival !== null;

  const currentPathStatus = sortedMileStoneDetails[milestoneIndex]?.pathDetails?.pathStatus;
  const confirmIndex = STATUS_LIST.indexOf("CONFIRM");
  const currentIndex = STATUS_LIST.indexOf(currentPathStatus);

  //add all possible console logs for debugging
    // console.log("isUserAdmin:", isUserAdmin);
    // console.log("isLastPath:", isLastPath);
    // console.log("activeTabLabel:", activeTabLabel);
    // console.log("isDestinationHub:", isDestinationHub);
    // console.log("isQuoteStarted:", isQuoteStarted);
    // console.log("isArrivalPresent:", isArrivalPresent);
    // console.log("currentPathStatus:", currentPathStatus);
    // console.log("confirmIndex:", confirmIndex);
    // console.log("currentIndex:", currentIndex);
    // console.log("controlTowerPermissions:", controlTowerPermissions);
    // console.log("sortedMileStoneDetails:", sortedMileStoneDetails);
    // console.log("milestoneIndex:", milestoneIndex);


  // Dates and Status tab
  if (activeTabLabel === "Dates and Status") {
    if (isUserAdmin) {
      // For admin: disable if not last path or last path with HUB
      if (controlTowerPermissions.controlTowerEditAccess === true) return false;
      if (controlTowerPermissions.controlTowerDatesandStatusTabAccess === true) return false;
      return false;
    } else {
      // For non-admin: disable if not last path, last path with HUB, or FOM STATUS > CONFIRM
      if (controlTowerPermissions.controlTowerDatesandStatusTabAccess === true) return true;
      return false;
    }
  }

  // Address tab
  if (activeTabLabel === "Address") {
    if (isUserAdmin) {
      // For admin: only disable for not last path or last path with HUB
      if (!isLastPath) return true;
      if (isLastPath && isDestinationHub) return true;
      return false;
    } else {
      // For non-admin: all the conditions listed
      if (!isLastPath) return true;
      if (isLastPath && isDestinationHub) return true;
      if (isLastPath && isQuoteStarted) return true;
      if (isLastPath && isArrivalPresent) return true;
      if (currentIndex > confirmIndex) return true; // Disable if FOM STATUS > CONFIRM for non-admin
      return false;
    }
  }

  // Transportation and Costing tab
  if (activeTabLabel === "Transportation and Costing") {
  
    if (!isUserAdmin) {
     // For non-admin: disable Transport and costing tab for user: U34FOMRO
      if (controlTowerPermissions.controlTowerTransportationAndCostingTabAccess === true) return true;
      return false;
    }
  }

  // Logs tab
  if (activeTabLabel === "Logs") {
    if (!isUserAdmin) {
     // For non-admin: disable Logs tab for user: U34FOMRO
      if (controlTowerPermissions.controlTowerLogsTabAccess === true) return true;
      return false;
    }
  }
  return false; 
}
